import React, { FC, ReactNode, useContext, useState } from 'react';
import styles from './styles/dropdown_pricing_button.module.scss';
import { Hyperlink } from '../../components/Hyperlink';
import { UserContext } from '../../user/UserContext';

type Props = {
  children: ReactNode;
  noHover: Boolean;
};

export const DropdownPricingButton: FC<Props> = ({ children, noHover }) => {
  const {
    currentUser: { daysRemaining, plan },
  } = useContext(UserContext);
  const [hovered, setHovered] = useState(false);

  const toggleDisplay = () => {
    setHovered(prevHover => !prevHover);
  };

  const conditionalSentence = (nb: number): string => {
    if (nb === 0) return 'Expiré';
    return `${nb} ${nb > 1 ? 'jours restants' : 'jour restant'}`;
  };

  const label = conditionalSentence(daysRemaining);

  const hasDaysRemaining = !plan;

  if (!hasDaysRemaining) return null;

  return (
    <Hyperlink
      className={styles.wrapper}
      href="/tarifs"
      source="nav"
      onMouseEnter={toggleDisplay}
      onMouseLeave={toggleDisplay}
    >
      <div className="flexible button button__small brand">{label}</div>
      {hovered && !noHover && (
        <span className={styles.secret}>
          <div className={styles.container}>
            <div className={styles.inside}>{children}</div>
          </div>
        </span>
      )}
    </Hyperlink>
  );
};
